import React from "react";
import { twMerge } from "tailwind-merge";

type CardProps = {
  inset?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

function Card({ inset = false, className, children, ...rest }: CardProps) {
  return (
    <div
      className={twMerge(
        "rounded-card border border-line-subtle",
        inset ? "bg-surface-inset" : "bg-surface-card",
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Card;
